var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-radiocards" },
    _vm._l(_vm.cards, function(card, i) {
      return _c(
        "div",
        {
          key: i,
          class: [
            "ui-radiocards__card",
            {
              "ui-radiocards__card_active":
                card.active || card.value === _vm.value
            },
            { "ui-radiocards__card_disabled": card.disabled }
          ],
          on: {
            click: function($event) {
              return _vm.cardClick(card)
            }
          }
        },
        [
          card.icon
            ? _c(
                "div",
                { staticClass: "ui-radiocards__icon" },
                [_c("f-sprite-icon", { attrs: { "icon-link": card.icon } })],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "ui-radiocards__card-inner" }, [
            _c("div", {
              staticClass: "ui-radiocards__title",
              domProps: { textContent: _vm._s(card.title) }
            }),
            _c("div", {
              staticClass: "ui-radiocards__subtitle",
              domProps: { textContent: _vm._s(card.subtitle) }
            }),
            _c(
              "div",
              { staticClass: "ui-radiocards__content" },
              [_vm._t("default", null, { value: card.value })],
              2
            ),
            _c(
              "div",
              { staticClass: "ui-radiocards__action" },
              [
                card.actionText && card.actionClick
                  ? _c("ui-button", {
                      attrs: { text: card.actionText, flat: "" },
                      on: { click: card.actionClick }
                    })
                  : _vm.showRadio
                  ? _c("div", { staticClass: "ui-radiocards__radio" })
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }